



















import { defineComponent, onUnmounted, ref, watch } from '@nuxtjs/composition-api';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';

import useVehicleYears from '~/composables/useVehicleYears';

import YearSelector from '../YearSelector/YearSelector.vue';
import useVehiclesByVin from './useVehiclesByVin';
import VehiclesVINSearchForm from './VehiclesVINSearchForm.vue';

interface VinSearchLookupEmitProps {
  emit: {
    (event: 'input', val: { vehicles: PartsDbVehicleSummary[]; exactYear: string | null }): void;
  };
}

export default defineComponent({
  components: {
    YearSelector,
    VehiclesVINSearchForm,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  setup(_: unknown, { emit }: VinSearchLookupEmitProps) {
    const vin = ref('');

    const { reset, vehicles, fetchVehicles, loading: loadingVehicles, error } = useVehiclesByVin();

    const { noExactYearFound, exactYear, possibleVehicleYears, updateExactYear } = useVehicleYears({
      vehicles,
    });

    onUnmounted(() => {
      reset();
    });

    watch([vehicles, exactYear], () => {
      emit('input', { vehicles: vehicles.value, exactYear: exactYear.value });
    });

    const handleSubmit = async (fetchedVin: string) => {
      vin.value = fetchedVin;
      await fetchVehicles(fetchedVin);
    };

    return {
      vin,
      handleSubmit,
      noExactYearFound,
      possibleVehicleYears,
      updateExactYear,
      loadingVehicles,
      error,
    };
  },
});
